import React, { useState, useEffect } from "react";
import { db, auth } from "../../config/firebase";
import { doc, getDoc, setDoc, updateDoc, arrayUnion } from "firebase/firestore";



// export default function CreateStudentLink({ collegeId, classId }) {
//   const [joinLink, setJoinLink] = useState("");

//   useEffect(() => {
//     if (collegeId && classId) {
//       setJoinLink(`http://localhost:3000/join/${collegeId}/${classId}`);
//     }
//   }, [collegeId, classId]);

//   const copyToClipboard = () => {
//     navigator.clipboard.writeText(joinLink);
//     alert("Link copied to clipboard!");
//   };

//   return (
//     <Box className="join-link-container">
//       <Typography variant="body1">{joinLink}</Typography>
//       <IconButton onClick={copyToClipboard}>
//         <LinkIcon />
//       </IconButton>
//     </Box>
//   );
// 
import { 
  Box, 
  Typography, 
  IconButton, 
  Button, 
  TextField,
  InputAdornment,
  Tooltip,
  Fade,
  Snackbar,
  Alert,
  Paper
} from "@mui/material";
import {
  Link as LinkIcon,
  ContentCopy,
  Check
} from "@mui/icons-material";
import { useParams, useNavigate } from "react-router-dom";

export default function CreateStudentLink({ collegeId, classId }) {
  const [joinLink, setJoinLink] = useState("");
  const [copied, setCopied] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    if (collegeId && classId) {
      // Use the current host instead of hardcoding localhost
      const currentUrl = `${window.location.origin}/join/${collegeId}/${classId}`;
      setJoinLink(currentUrl);
    }
  }, [collegeId, classId]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(joinLink);
    setCopied(true);
    setOpenSnackbar(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 2, bgcolor: 'background.paper' }}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
        Classroom Invitation Link
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Share this link with students to allow them to join this class
      </Typography>
      
      <TextField
        fullWidth
        value={joinLink}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip title="Copy link">
                <IconButton
                  onClick={copyToClipboard}
                  color={copied ? "success" : "primary"}
                  sx={{ mr: -1 }}
                >
                  {copied ? <Check fontSize="small" /> : <ContentCopy fontSize="small" />}
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ),
        }}
        sx={{ mt: 2 }}
      />

      <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
        <Button
          variant="outlined"
          startIcon={<LinkIcon />}
          onClick={copyToClipboard}
          sx={{ textTransform: 'none' }}
        >
          {copied ? 'Copied!' : 'Copy Link'}
        </Button>
        
        {/* <Tooltip title="Opens in a new tab to test the join flow">
          <Button
            variant="text"
            onClick={() => window.open(joinLink, '_blank')}
            sx={{ textTransform: 'none' }}
          >
            Test Link
          </Button>
        </Tooltip> */}
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
          Link copied to clipboard!
        </Alert>
      </Snackbar>
    </Paper>
  );
}
//Currently not in use. Refer to the JoinClassroom component.
export function JoinClass() {
  const { collegeId, classId } = useParams();
  const navigate = useNavigate();
  const [student, setStudent] = useState(null);
  const [isJoining, setIsJoining] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        validateStudent(user.uid);
      } else {
        navigate("/login");
      }
    });

    return () => unsubscribe();
  }, [collegeId, classId, navigate]);

  const validateStudent = async (userId) => {
    try {
      const studentRef = doc(db, "colleges", collegeId, "students", userId);
      const studentSnap = await getDoc(studentRef);

      if (studentSnap.exists()) {
        setStudent(studentSnap.data());
      } else {
        alert("You are not registered in this college.");
        navigate("/");
      }
    } catch (error) {
      console.error("Error validating student:", error);
    }
  };

  const joinClass = async () => {
    if (!student || isJoining) return;

    setIsJoining(true);

    try {
      const userId = auth.currentUser.uid;
      const classStudentRef = doc(
        db,
        "colleges",
        collegeId,
        "classes",
        classId,
        "students",
        userId
      );
      const studentRef = doc(db, "colleges", collegeId, "students", userId);

      // Step 1: Add student to class's students subcollection
      await setDoc(classStudentRef, {
        name: student.name,
        joinedAt: new Date(),
      });
      
      // Step 2: Update student's enrolledClasses array
      await updateDoc(studentRef, {
        enrolledClasses: arrayUnion(classId),
      });

      alert("You have successfully joined the class!");
      navigate(`/class/${classId}`);
    } catch (error) {
      console.error("Error joining class:", error);
    } finally {
      setIsJoining(false);
    }
  };

  return (
    <Box>
      <Typography variant="h6">
        Welcome, {student?.name}! Ready to join the class?
      </Typography>
      <Button variant="contained" onClick={joinClass} disabled={isJoining}>
        {isJoining ? "Joining..." : "Join Class"}
      </Button>
    </Box>
  );
}
